<table mat-table [dataSource]="controlExpedientes">
  <ng-container *ngFor="let column of headerColumns; let i = index" [matColumnDef]="column.name">
    <th mat-header-cell *matHeaderCellDef>
      {{ column.label }}
    </th>
    <td mat-cell *matCellDef="let row" nowrap>
      <ng-container [ngSwitch]="column.type">

        <ng-container *ngSwitchCase="'input'">
          <ng-container *ngIf="column.editable; else readOnlyInput">
            <div class="form-input" [ngClass]="{ editing: editableField.focused }">
              <input class="installation-input" matInput #editableField="matInput"
                [(ngModel)]="row[column.name]"
                (ngModelChange)="onComentariosChange($event, row)"
                [value]="row[column.name] || ''" />
              <bdr-icon icon="ico-edit" size="10"></bdr-icon>
            </div>
          </ng-container>
          <ng-template #readOnlyInput>{{ row[column.name] }}</ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="'select'">
          <ng-container *ngIf="column.editable; else readOnlySelect">
            <ng-container *ngIf="column.name === 'accion'; else motivoSelect">
              <mat-select
                class="selector-field"
                panelClass="ce-select-panel"
                [(ngModel)]="row.accion"
                (ngModelChange)="onAccionChange($event, row)">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let opt of acciones" [value]="opt">{{ opt }}</mat-option>
              </mat-select>
            </ng-container>
            <ng-template #motivoSelect>
              <mat-select
                class="selector-field"
                panelClass="ce-select-panel"
                [(ngModel)]="row.motivo"
                (ngModelChange)="onMotivoChange($event, row)"
                [disabled]="!row.accion">
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let opt of getMotivoOptions(row)" [value]="opt.motivo">{{ opt.label }}</mat-option>
              </mat-select>
            </ng-template>
          </ng-container>
          <ng-template #readOnlySelect>{{ row[column.name] }}</ng-template>
        </ng-container>

        <ng-container *ngSwitchDefault>{{ row[column.name] }}</ng-container>

      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>